import {  Grid, Link } from '@mui/material';
import ResponseWrapper from './ResponseWrapper'
import {ACCOUNT_SUBSCRIPTION_MANAGEMENT_LINK, PIONEER_RELATIVE_PATH} from '../utils/main-links'

type props = {
    buttonTitle: any, 
    description: any,
    title: any
    buttonSubTitle?: string
    success?: boolean
}

const ResponseNotLogged : React.FC<props> = props => {

    return (
        <ResponseWrapper>

            <Grid 
                container 
                alignItems='center'  
                flexDirection="column" 
                className='response-container-not-logged' 
                alignContent='center' 
                justifyContent={'center'}
            >

                <Grid item md={10}>
                    <p 
                        style={{ textAlign: 'center', fontSize: '20px', fontWeight: '700'}}
                    >
                        {props.title}
                    </p>
                </Grid>
                
                <Grid item md={10}>
                    {
                        props.description.length > 0 
                        ? 
                            <p style={{padding: '10px 0px', textAlign: 'center', marginTop: props.buttonTitle.includes('Return') ? '0px' : '' }}>
                                {props.description}
                            </p> 
                        : 
                            null
                    }
                    <p className='support-text' style={{marginTop: props.success ? '0px' : '15px'}}> If you have any questions or need help, please visit our <a href="//support.mutual.app">Help and Support page</a>. Thanks!</p>
                </Grid>
                {
                    props.success
                ? 
                    <Grid item md={8} className='back-mutual-wrapper' style={{marginTop: '15px'}}>
                        <Link href={ACCOUNT_SUBSCRIPTION_MANAGEMENT_LINK} className='back-mutual-link-inside'>{props.buttonTitle}</Link>
                    </Grid>
                    : 
                    <Grid item md={8} className='back-mutual-wrapper' style={{marginTop: '15px'}}>
                        <Link href={PIONEER_RELATIVE_PATH} className='back-mutual-link-inside'>{props.buttonTitle}</Link>
                    </Grid>
                }

                {
                    props.success ? <a className='back-mutual-link-logged' href={PIONEER_RELATIVE_PATH}>Back to sale page</a> : null
                }

            </Grid>
        </ResponseWrapper>
    );
}

export default ResponseNotLogged;
